import { Avatar, Divider, ListItemIcon, Menu, MenuItem, Switch } from '@mui/material';
import React, { useState } from 'react';
import { Action } from '../../models';
import FuelToggleButton from '../fuel-toggle-button/fuel-toggle-button';
import { FuelDuplicateIcon } from '../FuelIcons';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import { PersonAdd, Settings, Logout } from '@mui/icons-material';
import ActionBarMenu from './ActionBarMenu';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';

interface IProps {
  actions: Action[];
  item: any;
  onActionButtonClick: (event, type, item: any, context?: any) => void;
  context?: any;
}
const FuelActionbar = ({ actions, item, onActionButtonClick, context }: IProps) => {
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [menuItems, setMenuItems] = useState([]);
  const [type, setType] = useState('');

  const openMenu = (event: React.MouseEvent<HTMLElement>, submenus, type, item: any, context?: any) => {
    setMenuItems(() => submenus);
    setType(type);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event, type, item: any, context?: any) => {
    setAnchorEl(null);
    if (type) onActionButtonClick(event, type, item, context);
  };

  return (
    <div className="fuel-actionbar">
      {actions &&
        actions.length > 0 &&
        actions.map((a, i) => {
          return (
            <span key={a.type} data-key={a.type} className={a.className}>
              {a.component !== 'FuelToggleButton' &&
                a.component !== 'FuelDuplicateIcon' &&
                a.component !== 'MoreVertIcon' &&
                a.component !== 'RemoveCircleIcon' && (
                  <i
                    aria-hidden="true"
                    title={a.title}
                    onClick={(event) => onActionButtonClick(event, a.type, item, context)}
                    key={a.type}
                    className={`${a.iconClass} ${a.type}`}
                  >
                    {a.iconName}
                  </i>
                )}
              {a.component === 'FuelToggleButton' && (
                <FuelToggleButton
                  label={a.title}
                  value={item.enabled}
                  change={(event) => onActionButtonClick(event, a.type, item, context)}
                />
              )}
              {a.component === 'StarIcon' && (
                <span
                  className={a.iconClass}
                  title={a.title}
                  onClick={(e) => onActionButtonClick(e, a.type, item, context)}
                >
                  <StarIcon className={a.iconClass} sx={{ cursor: 'pointer' }}/>
                </span>
              )}
              {a.component === 'StarOutlineIcon' && (
                <span
                  className={a.iconClass}
                  title={a.title}
                  onClick={(e) => onActionButtonClick(e, a.type, item, context)}
                >
                  <StarOutlineIcon className={a.iconClass} sx={{ cursor: 'pointer' }}/>
                </span>
              )}
              {a.component === 'FuelDuplicateIcon' && (
                <FuelDuplicateIcon
                  className={a.iconClass}
                  title={a.title}
                  onActionButtonClick={(e) => onActionButtonClick(e, a.type, item, context)}
                />
              )}
              {a.component === 'MoreVertIcon' && (
                <span title={a.title} onClick={(e) => openMenu(e, a.submenus, a.type, item, context)}>
                  <MoreVertIcon className={a.iconClass} sx={{ cursor: 'pointer' }} />
                </span>
              )}
              {a.component === 'StopCircleOutlinedIcon' && (
                <span title={a.title} onClick={(event) => onActionButtonClick(event, a.type, item, context)}>
                  <StopCircleOutlinedIcon className={a.iconClass} />
                </span>
              )}
              {a.component === 'Timeline' && (
                <span title={a.title} onClick={(event) => onActionButtonClick(event, a.type, item, context)}>
                  <ViewTimelineOutlinedIcon className={a.iconClass} />
                </span>
              )}
              {a.component === 'RemoveCircleIcon' && (
                <span title={a.title} onClick={(event) => onActionButtonClick(event, a.type, item, context)}>
                  <RemoveCircleIcon className={a.iconClass} />
                </span>
              )}
            </span>
          );
        })}
      {anchorEl && (
        <ActionBarMenu
          anchorEl={anchorEl}
          open={open}
          handleClose={handleClose}
          item={item}
          type={type}
          context={context}
          submenus={menuItems}
        />
      )}
    </div>
  );
};

export default FuelActionbar;
